export default __webpack_public_path__ + "static/media/icon2.5cb4f333.png";